if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
        this.querySelector('.mobile-lightbox-nav')?.remove();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
        if (window.innerWidth < 750) {
          this.setupMobileNavigation();
        }
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }

      setupMobileNavigation() {
        this.querySelector('.mobile-lightbox-nav')?.remove();

        const allMedia = Array.from(this.querySelectorAll('[data-media-id]'));
        if (allMedia.length <= 1) return;

        this.currentIndex = allMedia.findIndex((el) => el.classList.contains('active'));

        const nav = document.createElement('div');
        nav.className = 'mobile-lightbox-nav';
        nav.style.cssText = `
          position: fixed;
          top: 0;
          left: 0;
          width: 100vw;
          height: 100vh;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 12px;
          box-sizing: border-box;
          z-index: 99999;
          pointer-events: none;
        `;

        const btnStyle = `
          pointer-events: all;
          background: rgba(255,255,255,0.85);
          border: none;
          border-radius: 50%;
          width: 44px;
          height: 44px;
          font-size: 24px;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 2px 8px rgba(0,0,0,0.2);
        `;

        const prevBtn = document.createElement('button');
        prevBtn.innerHTML = '&#8249;';
        prevBtn.setAttribute('aria-label', 'Previous image');
        prevBtn.style.cssText = btnStyle;
        prevBtn.addEventListener('click', (e) => { e.stopPropagation(); e.preventDefault(); this.navigateMobile(-1); });

        const nextBtn = document.createElement('button');
        nextBtn.innerHTML = '&#8250;';
        nextBtn.setAttribute('aria-label', 'Next image');
        nextBtn.style.cssText = btnStyle;
        nextBtn.addEventListener('click', (e) => { e.stopPropagation(); e.preventDefault(); this.navigateMobile(1); });

        nav.appendChild(prevBtn);
        nav.appendChild(nextBtn);
        this.appendChild(nav);
      }

      navigateMobile(direction) {
        const allMedia = Array.from(this.querySelectorAll('[data-media-id]'));
        allMedia[this.currentIndex].classList.remove('active');
        this.currentIndex = (this.currentIndex + direction + allMedia.length) % allMedia.length;
        allMedia[this.currentIndex].classList.add('active');
      }
    }
  );
}
